export default __webpack_public_path__ + "static/media/chevron-right.36985f53.svg";